import { render, staticRenderFns } from "./KeyBoard.vue?vue&type=template&id=5671fede&scoped=true&"
import script from "./KeyBoard.vue?vue&type=script&lang=js&"
export * from "./KeyBoard.vue?vue&type=script&lang=js&"
import style0 from "./KeyBoard.vue?vue&type=style&index=0&id=5671fede&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5671fede",
  null
  
)

export default component.exports